import { Icons, LabelChipV2, Stack, tokens } from '@cast/design-system';

const OnChip = () => <LabelChipV2 size="xs" color="blue" label="ON" />;

const OffChip = () => <LabelChipV2 size="xs" color="grey" label="OFF" />;

const ArrowRight = () => (
  <Icons.ArrowRight size={12} color={tokens.theme.fg.structural.secondary} />
);

export const OptimizationStatusDisabledChip = () => (
  <Stack direction="row" gap={6} alignItems="center">
    <OnChip />
    <ArrowRight />
    <OffChip />
  </Stack>
);

export const OptimizationStatusEnabledChip = () => (
  <Stack direction="row" gap={6} alignItems="center">
    <OffChip />
    <ArrowRight />
    <OnChip />
  </Stack>
);
